import AppConstants from '../../constants/AppConstants';
import store from '../../stores/redux';

const { dispatch } = store;

export const actions = {
    toggleNav(isNavExtended) {
        dispatch({
            type: AppConstants.IS_NAV_EXTENDED,
            isNavExtended
        });
    },
};
